import { useTranslation } from 'react-i18next';

// #105 (S1, plan D5): three progress bars with short labels (mockup .stepper),
// shown on steps 2 and 3 only. States: done / current / upcoming.
const KEYS = [
  'stepper.products',
  'stepper.preferences',
  'stepper.done',
] as const;

const Check = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 12l5 5L20 7" />
  </svg>
);

export default function Stepper({ currentStep = 0 }) {
  const { t } = useTranslation(['translation', 'dynamic']);

  return (
    <ol className="xc-stepper">
      {KEYS.map((key, index) => {
        const state =
          index < currentStep
            ? 'done'
            : index === currentStep
              ? 'current'
              : 'upcoming';
        return (
          <li
            key={key}
            className={`xc-step xc-step--${state}`}
            aria-current={state === 'current' ? 'step' : undefined}
          >
            <div className="xc-step__bar" />
            <div className="xc-step__label">
              {state === 'done' && <Check />}
              <span>{t(key)}</span>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
